import { Skeleton } from '@crehana/compass.ui/skeleton';

export function LoadingState() {
  return (
    <div className="tw-flex tw-flex-col tw-cds-gap-space-04 tw-py-space-04 tw-px-space-05">
      <div className="tw-flex tw-flex-col tw-gap-0">
        {[1, 2, 3, 4].map(i => (
          <div
            key={i}
            className="tw-cds-p-space-04 tw-flex tw-items-center tw-justify-between tw-cds-gap-space-04 tw-border-b tw-border-solid tw-cds-border-divider last:tw-border-b-0"
          >
            <div className="tw-flex-1 tw-space-y-space-02">
              <Skeleton className="tw-h-[1.8rem] tw-w-1/3 tw-cds-radius-s" />
              <Skeleton className="tw-h-[1.8rem] tw-w-2/3 tw-cds-radius-s tw-cds-mt-4" />
            </div>
            <Skeleton className="tw-cds-w-32 tw-cds-h-32 tw-cds-radius-s" />
            <Skeleton className="tw-cds-w-32 tw-cds-h-32 tw-cds-radius-s" />
          </div>
        ))}
      </div>
    </div>
  );
}
